import React, { useEffect, useState } from "react";
import Subheading from "../Common/Subheading";
import MonitoringListIcon from "../../assets/icons/monitoring/monitors_overview-01.svg2";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import SearchIcon from "../../assets/icons/search.svg2";
import MyFilterSubheading from "../Common/MyFilterSubheading";
import HelpButton from "../HelpContent/HelpButton";

function MonitorsListViewFilter({ filters, setFilters }) {
  const [search, setSearch] = useState([""]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setFilters((prev) => ({ ...prev, search }));
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [search]);

  return (
    <div className="text-white d-flex justify-content-between bg-colored-reverse bg-accross rounded-3 p-3 gap-3 align-items-center">
      <div className="flex-grow-1 svg-white">
        <div className="border-end border-opacity-50 border-secondary me-2 mt-2 text-nowrap">
          <MyFilterSubheading
            Icon={MonitoringListIcon}
            heading="Monitors:Overview"
            subheading="See all monitor statuses at a glance"
            iconWidth={50}
          />
        </div>
      </div>
      <div className="w-25 me-2">
        <label className="fw-bold p-2">
          Monitor Status:
          <HelpButton helpKey="monitor-status" btnClassName="ms-1 svg-white" />
        </label>
        <Input
          inputType="select"
          isMulti
          value={filters.status || []}
          placeholder="Monitor status"
          onChange={(values) => {
            setFilters((prev) => ({ ...prev, status: values }));
          }}
          options={[
            { value: "active", label: "Active" },
            { value: "draft", label: "Draft" },
            { value: "archived", label: "Archived" },
          ]}
        />
      </div>
      <div className="w-25 me-2 ">
        <label className="fw-bold p-2">
          Ping Status:
          <HelpButton
            helpKey="monitor-ping-status"
            btnClassName="ms-1 svg-white"
          />
        </label>
        <Input
          inputType="select"
          isMulti
          value={filters.ping_status || []}
          placeholder="Ping status"
          onChange={(values) => {
            setFilters((prev) => ({ ...prev, ping_status: values }));
          }}
          options={[
            { value: "ok", label: "ok" },
            { value: "failing", label: "failing" },
            { value: "failed", label: "failed" },
            { value: "recovering", label: "recovering" },
            { value: "unknown", label: "unknowns" },
          ]}
        />
      </div>
      {/* <div className="w-25 me-2 ">
        <label className="fw-bold p-2">Monitor Kind:</label>
        <div>
          <Input
            inputType="select"
            isMulti
            value={filters.kind || []}
            placeholder="Monitor kind"
            onChange={(values) => {
              setFilters((prev) => ({ ...prev, kind: values }));
            }}
            options={[
              { value: "filter-option-here", label: "Filter option here" },
              { value: "weather", label: "Weather" },
              { value: "communication", label: "Communication" },
              { value: "desktop_monitor", label: "Desktop Monitor" },
            ]}
          />
        </div>
      </div> */}
      <div className="w-25">
        <label className="fw-bold text-white p-2">
          Priority:{" "}
          <HelpButton
            helpKey="monitor-priority"
            btnClassName="ms-1 svg-white"
          />
        </label>
        <Input
          inputType="select"
          isMulti
          value={filters.priority || []}
          placeholder="Monitor priority"
          onChange={(values) => {
            setFilters((prev) => ({ ...prev, priority: values }));
          }}
          options={[
            { value: "high", label: "High" },
            { value: "medium", label: "Medium" },
            { value: "low", label: "Low" },
          ]}
        />
      </div>
      <div className="w-25">
        <label className="fw-bold text-white p-2">Search:</label>
        <div className="position-relative">
          <div
            className="top-50 end-0 translate-middle bg-colored text-white rounded-pill position-absolute text-center ms-2"
            style={{ width: 25, height: 25 }}
          >
            <SearchIcon width={12} heigth={12} className="white" />
          </div>
          <input
            placeholder="Search for a name/reference/description"
            className="form-control text-black text-nowrap pe-5 ps-2 py-2 rounded-3 w-100 "
            style={{ fontSize: "1rem" }}
            type="text"
            value={search[0]}
            onChange={(e) => {
              setSearch([e.target.value]);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default MonitorsListViewFilter;
